//import {GraphQLVoyager} from 'graphql-voyager';
//import '../../../../node_modules/graphql-voyager/dist/voyager.css';
import BBIFrame from './BBIFrame'
import './bbutil'

//var hans =require ('./test.json');

class BBVoyager extends BBIFrame {
  getUrl() {
    BBIFrame.scrolling = 'no'
    return `/${window.bbFolderName}/bbvoyager.html`
  }

  static getDescription() {
    return {
      name: 'BBVoyager',
      component: BBVoyager,
      label: 'BB Voyager',
      variables: [
        {
          name: 'query',
          type: 'yasgui',
          label: 'to fill the diagram. ( ?domainName ?rangeName ?propname)',
        },
        {
          name: 'height',
          type: 'string',
          label: 'optional css string for the height value',
        },
      ],
    }
  }
}

export default BBVoyager
